import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ConsentComplete } from '../models/consent-completed.model';
import { UpdateStatusModel } from '../models/updateStatus.model';
import { UpdateStudentStatusModel } from '../models/update-student-status.model';
import { StudentConsentModel } from '../models/student-consent.model';
import { AddressValidationUploadModel } from '../models/address-validation-upload.model';

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  constructor(private http: HttpClient) {}

  registerController = '/api/Register';
  postSubmission(body: Object, bo?: boolean): Observable<Object> {
    const endpoint = bo ? `/SaveSubmission?bo=${bo}` : '/SaveSubmission';
    return this.http.post<Object>(this.registerController + endpoint, body);
  }

  postQcOptionalInfo(body: Object): Observable<Object> {
    return this.http.post<Object>(
      this.registerController + '/UpdateSubmission',
      body
    );
  }

  confirmSubmission(body: UpdateStatusModel): Observable<Object> {
    return this.http.post<Object>(
      this.registerController + '/UpdateStudentStatus',
      body
    );
  }

  setStatus(studentId: number, status: number): Observable<Object> {
    return this.http
      .post<Object>(
        this.registerController + '/UpdateSingleRegistrationStatus',
        {
          studentId,
          status,
        }
      )
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  updateStudentStatus(
    statusUpdateObject: UpdateStudentStatusModel
  ): Observable<Object> {
    return this.http
      .post<Object>(
        `${this.registerController}/UpdateStudentStatus`,
        statusUpdateObject
      )
      .pipe(map((data) => data));
  }

  getDocusignToken(code: string): Observable<Object> {
    return this.http
      .get<Object>(this.registerController + `/docusignToken?code=${code}`)
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  createCompletedStudentConsent(
    consentData: ConsentComplete
  ): Observable<ConsentComplete> {
    return this.http
      .post<ConsentComplete>(
        this.registerController + `/CreateCompletedConsent`,
        consentData
      )
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  updateStudentConsentStatus(
    consentData: ConsentComplete
  ): Observable<StudentConsentModel> {
    return this.http
      .post<StudentConsentModel>(
        `${this.registerController}/UpdateStudentConsent`,
        consentData
      )
      .pipe(map((data) => data));
  }

  updateStudentConsentLinkStatus(
    consentData: ConsentComplete
  ): Observable<StudentConsentModel> {
    return this.http
      .post<StudentConsentModel>(
        `${this.registerController}/UpdateStudentConsentLink`,
        consentData
      )
      .pipe(map((data) => data));
  }

  downloadSignedDocument(envelopeId: string): Observable<any> {
    return this.http
      .get(this.registerController + `/DownloadSignedDocuments/${envelopeId}`, {
        responseType: 'arraybuffer',
      })
      .pipe(
        map((data) => {
          return new Blob([data], { type: 'application/pdf' });
        })
      );
  }

}
